import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../../../reducers/types";
import {
  setTripsFilter,
  populateTripQueryParams,
  clearAllSelections,
} from "../../actions/actions";
import { getTripsFilter, getTripsCounts } from "../../reducer";
import { MobileFilterDropdown } from "./component";

const mapStateToProps = (state: IStoreState) => ({
  tripsFilter: getTripsFilter(state),
  tripsCounts: getTripsCounts(state),
});

const mapDispatchToProps = {
  setTripsFilter,
  populateTripQueryParams,
  clearAllSelections,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IMobileFilterDropdownConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileFilterDropdown = connector(
  withRouter(MobileFilterDropdown)
);
